import { Card, Typography, Button, Tooltip } from "antd";
import { environmentConfig } from "@src/appV2/environment";

import meta from "../../../utils/meta";
import { useEffectivePermissions } from "@src/appV2/Auth/hooks/useEffectivePermissions";
import { useImpersonationSessions } from "@src/appV2/ImpersonationSessions/ImpersonationSessionsProvider";

const { Paragraph } = Typography;

function getImpersonateTooltip(canImpersonateUsers: boolean, phone?: string): string {
  if (!canImpersonateUsers) {
    return "You don't have permission to impersonate users.";
  }

  if (!phone) {
    return "Worker has no phone number.";
  }

  return "";
}

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'user' implicitly has an 'any' type.
export function AgentAppLinksCard({ user }) {
  const { openSession } = useImpersonationSessions();
  const { canImpersonateUsers } = useEffectivePermissions();

  const { workerOpenShiftsLink, workerDocsLink } = meta();
  const appDomain = `https://${window.location.hostname}`;
  const calendarLink = `${appDomain}/calendar?userId=${user._id}`;
  const profileLink = `${appDomain}/calendar?userId=${user._id}&drawer=Agent`;
  const signNewAgreementLink = environmentConfig.REACT_APP_HCP_SIGN_NEW_AGREEMENT_DEEPLINK;

  return (
    <Card title="Worker App Links">
      <Paragraph copyable={{ text: workerOpenShiftsLink }}>
        <a href={workerOpenShiftsLink} target="_blank">
          Open Shifts Link
        </a>
      </Paragraph>
      <hr />
      <Paragraph copyable={{ text: workerDocsLink }}>
        <a href={workerDocsLink} target="_blank">
          Document Link
        </a>
      </Paragraph>
      <hr />
      <Paragraph copyable={{ text: calendarLink }}>
        <a href={calendarLink} target="_blank">
          Admin Calendar Link
        </a>
      </Paragraph>
      <hr />
      <Paragraph copyable={{ text: profileLink }}>
        <a href={profileLink} target="_blank">
          Worker Profile Link
        </a>
      </Paragraph>
      <hr />
      <Paragraph>
        <Tooltip title={getImpersonateTooltip(canImpersonateUsers, user.agent?.phone)}>
          <Button
            disabled={!canImpersonateUsers || !user.agent?.phone}
            onClick={() => {
              const phone = user.agent?.phone;
              if (!phone) {
                return;
              }

              const cognitoUsername = `+1${phone}`;
              openSession(
                "worker",
                environmentConfig.REACT_APP_WORKER_APP_URL,
                user._id,
                user.agent?.name ?? "Unknown",
                cognitoUsername
              );
            }}
            type="link"
            className="rebrand-link"
          >
            Impersonate Worker
          </Button>
        </Tooltip>
      </Paragraph>
      <hr />
      <Paragraph copyable={{ text: signNewAgreementLink }}>
        <a href={signNewAgreementLink} target="_blank">
          Worker Sign New Agreement Link
        </a>
      </Paragraph>
    </Card>
  );
}
